import { Game } from '@bioliberty/core';

// 2 to 50 alphabetical characters that may contain single quotes, hyphens, periods
// or spaces as long as they are followed by one or more alphabetical characters
export const nameRegExp = /^(?=.{1,50}$)[A-Za-z0-9]+(?:['\-.\s][A-Za-z0-9]+)*$/;

export const passwordRegExp =
  /^(?!\s+)(?!.*\s+$)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ])[A-Za-z0-9$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]{8,256}$/;

export const devOnlyGames: string[] = [Game.DEV, Game.DEMO];

// sessionStorage key the mfa hand-off (SignInCallback -> MfaChallenge) is shared under.
export const MFA_SESSION_STORAGE_KEY = 'mfaSession';

export const chartColours = [
  '#2949f6',
  '#5a22a0',
  '#52817e',
  '#bd2c73',
  '#75471c',
  '#64992e',
  '#dba93a',
  '#6cc8c3',
  '#fc85ae'
];

export enum Route {
  Admin = '/admin',
  Authorize = '/api/authorize',
  Home = '/',
  MfaChallenge = '/sign-in/mfa',
  Organization = '/organization',
  SignInCallback = '/sign-in/callback',
  Patients = '/patients'
}
